/* ==========================================================================
   Sagheer Theme — Product page
   اختيار المتغيرات، تبديل الصور، الشريط الثابت للإضافة للسلة.
   ========================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;

    let productData;
    try { productData = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const variants = productData.variants || [];
    const form = root.querySelector('form[data-cart-form]');
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const priceWrap = root.querySelector('[data-price-wrap]');
    const submitBtn = root.querySelector('[data-add-button]');
    const buyBtn = root.querySelector('[data-buy-button]');
    const availabilityEl = root.querySelector('[data-availability]');
    const skuEl = root.querySelector('[data-sku]');
    const strings = (window.theme && window.theme.strings) || {};

    /* --------------------------- Media gallery --------------------------- */
    const slides = root.querySelectorAll('[data-media-id]');
    const thumbs = root.querySelectorAll('[data-thumb-id]');

    function showMedia(mediaId) {
      if (!mediaId) return;
      let found = false;
      slides.forEach(function (slide) {
        const match = slide.getAttribute('data-media-id') === String(mediaId);
        slide.classList.toggle('is-active', match);
        if (match) found = true;
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-thumb-id') === String(mediaId));
        thumb.setAttribute('aria-current', thumb.getAttribute('data-thumb-id') === String(mediaId) ? 'true' : 'false');
      });
      return found;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-thumb-id'));
      });
    });

    /* ------------------------- Variant selection ------------------------- */
    function getSelectedOptions() {
      const selected = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        const index = parseInt(group.getAttribute('data-option-index'), 10);
        const checked = group.querySelector('input:checked');
        const select = group.querySelector('select');
        selected[index] = checked ? checked.value : select ? select.value : null;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (variant) {
        return selected.every(function (value, i) {
          return value === null || variant.options[i] === value;
        });
      });
    }

    // تعطيل الخيارات غير المتاحة (مثلًا مقاس نفد في لون معيّن)
    function updateOptionAvailability(selected) {
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        const index = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          const test = selected.slice();
          test[index] = input.value;
          const match = variants.find(function (variant) {
            return test.every(function (value, i) {
              return value === null || variant.options[i] === value;
            });
          });
          input.disabled = !match || !match.available;
        });
      });
    }

    function updateLabels() {
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        const label = group.querySelector('[data-option-value]');
        const checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });
    }

    function updatePrice(variant) {
      if (!priceWrap) return;
      const amountEl = priceWrap.querySelector('[data-price-amount]');
      const compareEl = priceWrap.querySelector('[data-price-compare]');
      const discountEl = priceWrap.querySelector('[data-price-discount]');
      if (amountEl) amountEl.textContent = window.Theme.formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceWrap.classList.toggle('price--on-sale', !!onSale);
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = window.Theme.formatMoney(variant.compare_at_price);
      }
      if (discountEl) {
        discountEl.hidden = !onSale;
        if (onSale) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          discountEl.textContent = '-' + pct + '%';
        }
      }
    }

    function updateButtons(variant) {
      if (!submitBtn) return;
      if (!variant) {
        submitBtn.disabled = true;
        submitBtn.textContent = strings.unavailable || 'غير متوفر حاليًا';
      } else if (!variant.available) {
        submitBtn.disabled = true;
        submitBtn.textContent = strings.sold_out || 'نفد من المخزون';
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = strings.add_to_cart || 'أضف للسلة';
        submitBtn.dataset.originalText = submitBtn.textContent;
      }
      if (buyBtn) buyBtn.hidden = !variant || !variant.available;
    }

    function updateUrl(variant) {
      if (!variant || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function onVariantChange() {
      const selected = getSelectedOptions();
      updateOptionAvailability(selected);
      updateLabels();
      const variant = findVariant(selected);

      if (idInput && variant) idInput.value = variant.id;
      if (variant) {
        updatePrice(variant);
        if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
        if (availabilityEl) {
          availabilityEl.textContent = variant.available ? (strings.in_stock || 'متوفر') : (strings.sold_out || 'نفد من المخزون');
          availabilityEl.classList.toggle('product__availability--out', !variant.available);
        }
        if (skuEl) skuEl.textContent = variant.sku || '';
        updateUrl(variant);
      }
      updateButtons(variant);
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: variant } }));

      // تحديث سعر الشريط الثابت
      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && variant) stickyPrice.textContent = window.Theme.formatMoney(variant.price);
    }

    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.addEventListener('change', onVariantChange);
    });

    onVariantChange();

    /* ------------------------------ Buy now ------------------------------ */
    if (buyBtn && form) {
      buyBtn.addEventListener('click', function () {
        window.Theme.addToCart(new FormData(form), buyBtn).then(function () {
          window.location.href = '/checkout';
        });
      });
    }

    /* --------------------------- Sticky add to cart ---------------------- */
    const sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && submitBtn) {
      document.body.classList.add('has-sticky-atc');
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      observer.observe(submitBtn);

      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        if (window.innerWidth < 990) {
          submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  });
})();
